import React from 'react';
import ListView from "../components/List/BookingList";

export default function AllBookings() {
 
    return (
        <>
            <h2 className="py-1 pb-4 text-2xl font-gilroy font-semibold text-[#263238]">Bookings</h2>
            <div className="bg-white h-[calc(100vh-180px)] overflow-y-hidden rounded-md">
                <ListView/>
            </div>
        </>
    )
}
    